import React, {Fragment} from 'react';
import Intro from './Intro';
import BlogMain from '../subscribers/blog/BlogMain';
import WorksMain from '../subscribers/works/WorksMain'
import SectionTitle from "./SectionTitle";

export default function (props) {
    return(
        <Fragment>
            <Intro/>
            <SectionTitle title={"Artículos Recientes"}/>
            <BlogMain/>
            <SectionTitle title={"Trabajos Recientes"}/>
            <WorksMain/>
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/visitors/components/Main.js